export const POLAND_COUNTRY_CODE = 'pl'

export const isPoland = (countryCode?: string) =>
  countryCode?.toLowerCase() === POLAND_COUNTRY_CODE
